'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiError = exports.isCoveToken = exports.tokenExpiry = exports.tokenExpired = exports.Embargo = exports.Auth = exports.Feedback = exports.Media = exports.Test = exports.Vehicle = exports.Token = exports.Risk = exports.Quote = exports.Pulse = exports.PaymentMethod = exports.Payment = exports.PartnerPetQuote = exports.PartnerQuote = exports.Item = exports.Customer = exports.Coverage = exports.Claim = undefined;

var _Claim = require('./api/Claim');

var _Claim2 = _interopRequireDefault(_Claim);

var _Coverage = require('./api/Coverage');

var _Coverage2 = _interopRequireDefault(_Coverage);

var _Customer = require('./api/Customer');

var _Customer2 = _interopRequireDefault(_Customer);

var _Item = require('./api/Item');

var _Item2 = _interopRequireDefault(_Item);

var _PartnerQuote = require('./api/PartnerQuote');

var _PartnerQuote2 = _interopRequireDefault(_PartnerQuote);

var _Pulse = require('./api/Pulse');

var _Pulse2 = _interopRequireDefault(_Pulse);

var _PartnerPetQuote = require('./api/PartnerPetQuote');

var _PartnerPetQuote2 = _interopRequireDefault(_PartnerPetQuote);

var _Payment = require('./api/Payment');

var _Payment2 = _interopRequireDefault(_Payment);

var _PaymentMethod = require('./api/PaymentMethod');

var _PaymentMethod2 = _interopRequireDefault(_PaymentMethod);

var _Quote = require('./api/Quote');

var _Quote2 = _interopRequireDefault(_Quote);

var _Risk = require('./api/Risk');

var _Risk2 = _interopRequireDefault(_Risk);

var _Token = require('./api/Token');

var _Token2 = _interopRequireDefault(_Token);

var _Vehicle = require('./api/Vehicle');

var _Vehicle2 = _interopRequireDefault(_Vehicle);

var _Test = require('./api/Test');

var _Test2 = _interopRequireDefault(_Test);

var _Media = require('./api/Media');

var _Media2 = _interopRequireDefault(_Media);

var _Feedback = require('./api/Feedback');

var _Feedback2 = _interopRequireDefault(_Feedback);

var _Auth = require('./api/Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _Embargo = require('./api/Embargo');

var _Embargo2 = _interopRequireDefault(_Embargo);

var _ApiClient = require('./lib/ApiClient');

var _TokenUtils = require('./lib/TokenUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file index.js
 * Library for performing various CoveAPI requests
 * @author Ming Cheuk <ming.cheuk@coveinsurance.co.nz>
 * @copyright Copyright Cove Limited 2017. All rights reserved.
 *
 */

exports.Claim = _Claim2.default;
exports.Coverage = _Coverage2.default;
exports.Customer = _Customer2.default;
exports.Item = _Item2.default;
exports.PartnerQuote = _PartnerQuote2.default;
exports.PartnerPetQuote = _PartnerPetQuote2.default;
exports.Payment = _Payment2.default;
exports.PaymentMethod = _PaymentMethod2.default;
exports.Pulse = _Pulse2.default;
exports.Quote = _Quote2.default;
exports.Risk = _Risk2.default;
exports.Token = _Token2.default;
exports.Vehicle = _Vehicle2.default;
exports.Test = _Test2.default;
exports.Media = _Media2.default;
exports.Feedback = _Feedback2.default;
exports.Auth = _Auth2.default;
exports.Embargo = _Embargo2.default;
exports.tokenExpired = _TokenUtils.tokenExpired;
exports.tokenExpiry = _TokenUtils.tokenExpiry;
exports.isCoveToken = _TokenUtils.isCoveToken;
exports.ApiError = _ApiClient.ApiError;